/* eslint-disable max-len */
import { SvgProps } from './types'

export const PercentArrowDownIcon = ({ color, className, ...rest }: SvgProps) => {
  let drawColor = color
  if (drawColor === 'blue') {
    drawColor = '#00BFFF'
  } else if (drawColor === 'pink') {
    drawColor = '#CC00A1'
  }

  return (
    <svg
      width="40"
      height="41"
      viewBox="0 0 40 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...rest}
    >
      <path
        d="M28.2141 2.50293V23.8634H34.2975L19.6469 38.5029L5 23.8634H10.8573"
        stroke={drawColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.6946 6.41016L10.79 15.0811"
        stroke={drawColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.97095 10.8108C10.9926 10.8108 11.8208 9.98259 11.8208 8.96094C11.8208 7.93929 10.9926 7.11108 9.97095 7.11108C8.9493 7.11108 8.12109 7.93929 8.12109 8.96094C8.12109 9.98259 8.9493 10.8108 9.97095 10.8108Z"
        stroke={drawColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.51 14.3767C17.5317 14.3767 18.3599 13.5485 18.3599 12.5269C18.3599 11.5052 17.5317 10.677 16.51 10.677C15.4884 10.677 14.6602 11.5052 14.6602 12.5269C14.6602 13.5485 15.4884 14.3767 16.51 14.3767Z"
        stroke={drawColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.8369 3.32591C15.7507 2.7995 14.531 2.50293 13.241 2.50293C8.6886 2.50293 5 6.19153 5 10.7439C5 15.2963 8.69231 18.9886 13.2447 18.9886C17.797 18.9886 21.4893 15.2963 21.4893 10.7439C21.4893 8.95335 20.9184 7.29996 19.9509 5.94686"
        stroke={drawColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
